import React, { FC } from "react";

type SummaryPartProps = {
  label: string;
  content?: string;
  additionalContent?: string;
  showJobTitle?: boolean;
  style?: React.CSSProperties | undefined;
};

export const SummaryPart: FC<SummaryPartProps> = ({
  label,
  content,
  additionalContent,
  children,
  showJobTitle,
  style,
}) => {
  return (
    <div>
      <dt className="d-inline-block fw-normal">{label}:&nbsp;</dt>
      <dd className="d-inline-block fw-bold" style={style}>
        {content ?? children}&nbsp;
      </dd>
      {additionalContent && showJobTitle && (
        <dd className="d-inline-block fw-normal">{additionalContent}</dd>
      )}
    </div>
  );
};
